import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_ASSET_MGMT_API } from '../utils/AxoisUtilComponent';
import { formatDate } from '../utils/timeUtils';
import TemplateListView    from "./TemplateListView";
import AssetCollAdminDetailsView from "./AssetCollAdminDetailsView";
import AssetCollAdminNewView     from "./AssetCollAdminNewView";


const AssetCollAdmin = () => {

  const { t } = useTranslation(["common"]);

  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "AssetCollAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'name',
      name: t("I18N_Name"),
      sortable: true,
      sortField: 'name',
      grow: 2,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2
    },
    {
      name: t("I18N_Alarm_susp_status"),
      selector: row => row.almSuspStatus,
      grow: 2
    },
    {
      name: t("I18N_Alarm_susp_start"),
      selector: row => formatDate(row.almSuspStartTime),
      grow: 2
    },
    {
      name: t("I18N_Alarm_susp_expire"),
      selector: row => formatDate(row.almSuspEndTime),
      grow: 2
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_ASSET_MGMT_API}
                                                  apiObjName={'asset-colls'}
                                                  listPageTitle={t("I18N_AssetColl_Mgmt")}
                                                  newObjTooltip={t("I18N_TIP_New_asset_coll")}
                                                  deleteConfirmDialogTitle={t("I18N_AssetColl_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_asset_coll")}
                                                  searchTooltip={t("I18N_Search")}
                                                  tableColumns={tableColumns}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <AssetCollAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <AssetCollAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default AssetCollAdmin;
